import { gql } from "@apollo/client";

export const GET_IDV_CONFIGURATION = gql`
  query getIdvConfiguration($configurationId: String!) {
    getIdvConfiguration(configurationId: $configurationId) {
      id
      verificationPoints {
        customerRegistration {
          enabled
          required
        }
        bookingCreation {
          enabled
          required
        }
        driverProfile {
          enabled
          required
        }
      }
      creditUsage {
        enabled
        availableCredits
      }
    }
  }
`;
